// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"52de51d2","404":"0cc4b59a","513":"03aa3046"}[chunkId] + ".chunk.js";
};